import { ProblemDetails, ProblemDetailsFactory } from "./interfaces.js";
import * as Problems from "./problems.js";

export { ProblemDetails, ProblemDetailsFactory, Problems };
/**
 * The default format for Api errors
 */
export class ApiError extends Error {
  public type: string;
  public status: number;
  public detail?: string;
  public instance?: string;
  public extra?: Record<string, unknown>;

  constructor(problem: ProblemDetails, options?: ErrorOptions) {
    super(problem.title, options);

    if (!problem.type.startsWith("https://zup.fail/")) {
      throw new Error(
        `Invalid 'type' specified on ApiError, must be a URI starting with 'https://zup.fail/'. Type was set to ${problem.type}`
      );
    }

    const { type, status, detail, instance, ...extra } = problem;
    this.name = "ApiProblemError";
    this.type = type;
    this.status = status;
    this.detail = detail;
    this.instance = instance;
    this.extra = extra;
  }
}

/**
 * Not found error
 */
export class ApiNotFoundError extends ApiError {
  constructor(problem: Pick<ProblemDetails, "detail" | "instance"> = {}) {
    super({
      ...problem,
      ...Problems.NOT_FOUND,
    });
    this.name = "ApiNotFoundProblemError";
  }
}

/**
 * Check if the value is a ProblemDetails
 * @param val - the value to check
 * @returns True if the object is a ProblemDetails
 */
export function isProblemDetails(val: unknown): val is ProblemDetails {
  return (
    val !== undefined &&
    val !== null &&
    typeof val === "object" &&
    "type" in val &&
    "title" in val &&
    "status" in val &&
    typeof val.type === "string" &&
    typeof val.title === "string" &&
    typeof val.status === "number"
  );
}
